/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_BundledInputs */

const cs_franchise_bundled = /** @type {(inputs: Franchise_BundledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software v licenci`)
};

const en_franchise_bundled = /** @type {(inputs: Franchise_BundledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software included in license`)
};

/**
* | output |
* | --- |
* | "Software included in license" |
*
* @param {Franchise_BundledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_bundled = /** @type {((inputs?: Franchise_BundledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_BundledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_bundled(inputs)
	return cs_franchise_bundled(inputs)
});